package com.zaurh.portfolio.di

import com.zaurh.portfolio.data.repository.ContactRepositoryImpl
import com.zaurh.portfolio.domain.repository.ContactRepository
import com.zaurh.portfolio.main.MainViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

val repositoryModule = module {

    single<ContactRepository> {
        ContactRepositoryImpl(get())
    }

    viewModel { MainViewModel(get()) }
}